<template>
  <sp-button :tag="tag" :href="url" :color="color" :variant="variant">
    <slot>{{ label }}</slot>
  </sp-button>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  label: {
    type: String,
    default: undefined,
  },
  url: {
    type: String,
    default: undefined,
  },
  color: {
    type: String,
    default: undefined,
  },
  variant: {
    type: String,
    default: undefined,
  },
});

const tag = computed(() => (props.url ? "a" : undefined));
</script>

<style>
:host {
  display: block;
}
</style>
